import React from 'react';

/**
 * This is the main Fast Facts component.
 * It renders a group of cards with an icon, title, and text.
 */

const FastFacts = ({ cards = [],
                     textColorClass = '',
                     headingColorClass = '',
                     title = 'Fast Facts'
                    }) => {

  // Assign the correct column class based on the number of cards
  const columnClass = cards.length === 3 ? 'col-lg-4 col-md-6 mb-4' : 'col-lg-3 col-md-6 mb-4';

  // Limit the length of the title and content
  const truncateTitle = (title) => title.length > 50 ? title.slice(0, 50) + '...' : title;
  const truncatedContent = (content) => content.length > 150 ? content.slice(0, 150) + '...' : content;

  // console.log ("Fast Facts: ", { cards, textColorClass, headingColorClass, title });

  // The HTML for Fast Facts
  return (
    <div className="fast-facts container-fluid">
      <h2 className={`text-center ${headingColorClass ? `heading-color-${headingColorClass}` : ''}`}>
        {title}
      </h2>
      <div className="row">
        {/* Map through the cards and create a column for each one */}
        {cards.map((card, index) => (
          <div className={columnClass} key={index}>
            <div className="card">
              <div className="card-img-wrapper">
                <img
                  src={card.icon || ""}
                  className="fast-fact-icon"
                  alt={card.altText || ""}
                />
              </div>
              <div className="card-body">
                <p className={`card-title subhead h3 ${headingColorClass ? `heading-color-${headingColorClass}` : ''}`}>
                  {truncateTitle(card.title)}
                </p>
                <p className={`card-text ${textColorClass ? `text-color-${textColorClass}` : ''}`}>
                  {truncatedContent(card.text)}
                </p>

              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

};

export default FastFacts;
